export enum Edition {
  God,
  Allah,
}
